











import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';
import Nara from '@/domain/product/Nara';

@Component
export default class NaraIcons extends Vue {
  @Prop({required: false, default: () => []})
  public naras: Nara[];
}
